var animationSpeed = 300; // ms

/**
 * Product form expanding and collapsing in the product instance view if required
 */
$('.toggle-link').on('click', 'a', function() {
    var toggleable = $(this).closest('.toggle-link').next();
    $(this).toggleClass('collapsed expanded');
    $('span', this).toggleClass('glyphicon-plus-sign glyphicon-minus-sign');
    if ($(this).hasClass('collapsed')) {
        toggleable.slideUp(animationSpeed);
    } else {
        toggleable.slideDown(animationSpeed);
    }
}).find('.collapsed').closest('.toggle-link').next().hide();

/**
 * collapse row and remove expanded css
 *
 * @param DomObject jqo a table-row(clicked row or sblung row)
 *
 * @returns void
 */
function collapseGeneratorLine(jqo) {
    //remove all other open tr whose class is "generator-form-holder"
    $('.generator-form-holder').empty().remove();

    // after collapse remove expanded css from row
    jqo.removeClass('expanded');
}

/**
 * expand row and load generator form and
 * add expanded css to the row
 *
 * @param DomObject jqo a clicked table-row
 *
 * @returns void
 */
function expandGeneratorLine(jqo) {
    var generatorId = jqo.data('generatorId'),
        instanceId = jqo.data('instanceId'),
        showUrl = jqo.data('showUrl'),
        $formHolder = $('<tr class="generator-form-holder"><td colspan="5"></td></tr>');
        url = instanceId ? showUrl + generatorId + '/' + instanceId : showUrl + generatorId;
    //add new tr after jqo(tr)
    jqo.after($formHolder);

    //call generatorFormLoad function
    generatorFormLoad($formHolder, url);

    //add expanded to the clicked row
    jqo.addClass('expanded');
}

/**
 * load generator form in the formHolder container
 *
 * @param DomObject formHolder a formHolder container
 *
 * @param string url form load URL
 *
 * @returns void
 */
function generatorFormLoad($formHolder, url) {
    // If we have an instance pass it into the url to be prefilled
    $('td', $formHolder).load(url, function(responseTxt, statusTxt, xhr) {

        if (statusTxt == 'error' && responseTxt == 'Not logged in') {
            return document.location.reload(true);
        }

        $('form', $formHolder).slideDown(animationSpeed);

        if ($(this).closest('[data-station-id]')) {
            var stationId = $(this).closest('[data-station-id]').data('stationId')

            if (stationId) {
                $('[name="Station"]', $formHolder).val(stationId);
                $('[name="Stations[]"]', $formHolder).val([stationId]);
            }
        }

        // No idea why this is needed. The f/e form as shown to users is identical to
        // the one used in ClassicView.
        var $datepickerField = $('[data-showcalendar="data-showcalendar"]', $formHolder);
        $datepickerField.datepicker({dateFormat: $datepickerField.data('jquerydateformat')});

        $('[name="Station"]', $formHolder).wrap('<div class="select-wrapper" />').select2();
        $('[name="Stations[]"]', $formHolder).select2(); // No wrapper, we don't need the arrow that's applied
        $('[name="Language"]', $formHolder).wrap('<div class="select-wrapper" />');
    });
}

/**
 * Reset expand/collapse indicators
 *
 * @param DomObject $tr a clicked table-row
 * @returns void
 */
function toggleRow($tr) {
    // if any other row is already expanded, then reset icon and collapse for that row
    if(($expandedTR = $tr.siblings('.expanded')) && $tr.siblings('.expanded').length) {
        resetIndicator($expandedTR, 'up', 'down');
        collapseGeneratorLine($expandedTR);
    }
    // Collapse clickable row if it is already expanded
    if ($tr.find('i.fa').hasClass('fa-angle-double-up')) {
        resetIndicator($tr, 'up', 'down');
        collapseGeneratorLine($tr);
    // expand clickable row if it is collapse
    } else {
        resetIndicator($tr, 'down', 'up');
        expandGeneratorLine($tr);
    }
}

/**
 * Reset expand/collapse indicator
 *
 * @param DomObject $tr a table-row
 * @returns void
 */
function resetIndicator($tr, $remove, $add) {
    $tr.find('i.fa')
        .removeClass('fa-angle-double-' + $remove)
        .addClass('fa-angle-double-' + $add);
}

$('[role="main"]').on('click', '[data-click-to-run]', function(e) {
    e.stopImmediatePropagation();
    //get the clicked row
    $tRow = $(this).closest('tr');
    //call toggleRow function
    toggleRow($tRow);
}).on('submit', '.run-form', function() {
  var tobedisabled = $(this).closest('td');
  if (!tobedisabled.length) tobedisabled = $(this);
    tobedisabled.addClass('executing');
});
